export const HIDE_MODAL = 'HIDE_MODAL';
export const HIDE_ON_LOADING = 'HIDE_ON_LOADING';
export const HIDE_ON_SKELETON = 'HIDE_ON_SKELETON';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const HIDE_BANNERS = 'HIDE_ON_BANNERS';
export const SET_CONTACT_EMAIL = 'SET_CONTACT_EMAIL';
export const SET_DOCUMENTS_TYPES = 'SET_DOCUMENTS_TYPES';
export const SET_BANK_CODES = 'SET_BANK_CODES';
export const SET_NPS_WIDGET = 'SET_NPS_WIDGET';
export const SET_LEGAL_TEXT = 'SET_LEGAL_TEXT';
export const SET_MODAL_DATA_AND_SHOW = 'SET_MODAL_DATA_AND_SHOW';
export const SET_MODAL_RESULT = 'SET_MODAL_RESULT';
export const SET_ROUTER = 'SET_ROUTER';
export const SET_SNACKBAR_DATA_AND_SHOW = 'SET_SNACKBAR_DATA_AND_SHOW';
export const SET_SNACKBAR_RESULT = 'SET_SNACKBAR_RESULT';
export const SHOW_ERR_MSG = 'SHOW_ERR_MSG';
export const SHOW_ON_LOADING = 'SHOW_ON_LOADING';
export const SHOW_ON_SKELETON = 'SHOW_ON_SKELETON';
export const SHOW_BANNERS = 'SHOW_BANNERS';
export const SET_MODAL = 'COMMON/SET_MODAL';
export const SKIP_SKELETON_LOADER_ONCE = 'SKIP_SKELETON_LOADER_ONCE';
export const SET_FORM_VALIDATION_ERRORS = 'SET_FORM_VALIDATION_ERRORS';
export const SET_TIMER_SENT_EMAIL = 'COMMON/SET_TIMER_SENT_EMAIL';
